<div class="entity-parent">
    <label id="entity-radio-group-label" class="entity-radio-group-label">{{ "userData.selectEntity" | cxTranslate }}</label>
    <div *ngIf="!selectId">
      <div class="vs-radio-button" *ngFor="let entity of legalEntitisList?.vsSalesArea; let i=index">
        <input id="{{i}}" type="radio" [value]="entity.salesOrganization" 
        (click)="onEntityChange(entity)"
        [checked]="entity.salesOrganization == this.defaultEntity">
        <label for="{{i}}" class="entity-radio-label">
          {{entity.salesOrganization}}
          <!-- , {{entity.currency.isocode}} ({{entity.currency.symbol}}) -->
        </label>
    </div>
  </div>
  <div *ngIf="selectId">
    <div *ngIf="legalEntitisList$ | async as legalEntitisLists else loading">
      <div class="vs-radio-button" *ngFor="let entity of legalEntitisLists?.vsSalesArea; let i=index">
        <input id="{{i}}" type="radio" [value]="entity.salesOrganization" 
        (click)="onEntityChange(entity)"
        [checked]="entity.salesOrganization== this.defaultEntity">
        <label for="{{i}}" class="entity-radio-label">
          {{entity.salesOrganization}}
          <!-- , {{entity.currency.isocode}} ({{entity.currency.symbol}}) -->
        </label>
      </div>
    </div>
  </div>
    <div class="entity-actionButton">
      <div class="ter-btn-holder" (click)="backTo()">
        <button class="vs-tertiary-btn">{{ "userData.back" | cxTranslate }}        
        </button>
      </div>
  
      <button (click)="update()" class="vs-primary-btn" [ngClass]="change ? 'entity-update-enable' : 'entity-update'">
        <span>{{ "userData.update" | cxTranslate }}</span>
      </button>
    </div>
  </div>
  <ng-template #loading>
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  </ng-template>
